export const GOOGLE_MAP_API_KEY = 'AIzaSyCjJZy6y9QWURYk8LCyh0HItkVFH3M0tOU';
